import HttpBaseService from '@/services/http/HttpBaseService'
import Event from '@/objects/Event'

class EventService extends HttpBaseService {

  fetchEvents = async () => {
    const response = await this.executeRequest('/content-api/collections/events/entries?sort=order', 'GET')
    const result = response.data.map(e => {
      return new Event(e)
    })
    console.log('result', result)
    return result
  }

  fetchEvent = async (id) => {
    const response = await this.executeRequest(`/content-api/collections/events/entries/${id}`, 'GET')
    console.log('response.data: ', response.data)
    return new Event(response.data)
  }

}

export default new EventService()
